var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "19",
        height: "21",
        viewBox: "0 0 19 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.92355 8.28571C6.92355 8.04464 6.73605 7.85714 6.49498 7.85714H5.63784C5.39676 7.85714 5.20926 8.04464 5.20926 8.28571V16C5.20926 16.2411 5.39676 16.4286 5.63784\n    16.4286H6.49498C6.73605 16.4286 6.92355 16.2411 6.92355 16V8.28571ZM10.3521 8.28571C10.3521 8.04464 10.1646 7.85714 9.92355 7.85714H9.06641C8.82534 7.85714 8.63784\n     8.04464 8.63784 8.28571V16C8.63784 16.2411 8.82534 16.4286 9.06641 16.4286H9.92355C10.1646 16.4286 10.3521 16.2411 10.3521 16V8.28571ZM13.7807 8.28571C13.7807\n     8.04464 13.5932 7.85714 13.3521 7.85714H12.495C12.2539 7.85714 12.0664 8.04464 12.0664 8.28571V16C12.0664 16.2411 12.2539 16.4286 12.495 16.4286H13.3521C13.5932\n     16.4286 13.7807 16.2411 13.7807 16V8.28571ZM15.495 17.9821C15.495 18.625 15.1334 19 15.0664 19H3.92355C3.85659 19 3.49498 18.625 3.49498\n     17.9821V5.28571H15.495V17.9821ZM6.49498 3.57143L7.15123 2.00446C7.19141 1.95089 7.29855 1.87053 7.37891 1.85714H11.6244C11.6914 1.87053\n     11.8119 1.95089 11.8521 2.00446L12.495 3.57143H6.49498ZM18.9236 4C18.9236 3.75893 18.7361 3.57143 18.495 3.57143H14.3566L13.4191 1.33482C13.1512\n     0.678571 12.3477 0.142856 11.6378 0.142856H7.35212C6.6423 0.142856 5.83873 0.678571 5.57087 1.33482L4.63337 3.57143H0.494978C0.253906 3.57143 0.0664062\n     3.75893 0.0664062 4V4.85714C0.0664062 5.09821 0.253906 5.28571 0.494978 5.28571H1.78069V18.0357C1.78069 19.5089 2.74498 20.7143 3.92355 20.7143H15.0664C16.245\n     20.7143 17.2093 19.4554 17.2093 17.9821V5.28571H18.495C18.7361 5.28571 18.9236 5.09821 18.9236 4.85714V4Z",
          fill: "#D13737",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }